import { useMatches } from "react-router"
import type { DehydratedState } from "@tanstack/react-query"

// Vendored from https://github.com/maplegrove-io/use-dehydrated-state
export function useDehydratedState(): DehydratedState | undefined {
  const matches = useMatches()

  const dehydratedStates = matches
    .map(
      (match) =>
        (match.loaderData as { dehydratedState?: DehydratedState } | undefined)
          ?.dehydratedState,
    )
    .filter((state): state is DehydratedState => Boolean(state))

  if (!dehydratedStates.length) return undefined

  return dehydratedStates.reduce((accumulator, current) => ({
    queries: [...accumulator.queries, ...current.queries],
    mutations: [...accumulator.mutations, ...current.mutations],
  }))
}
